import { Fragment } from 'react';

import { NsContent } from '@britishgasenergy/react-nucleus/dist';
import NsColumn from '@britishgasenergy/react-nucleus/dist/nuc-components/NsColumn';
import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { NsList } from 'components/common/ns-list/NsList';
import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';
import { NsCaveatLink } from 'components/common/ns-caveat-link/NsCaveatLink';

export const testId = 'aboutHeatPumpTestId';

export const AboutHeatPump = () => {
  const switchCaveatId = 'swtichCaveat';
  return (
    <>
      <NsPanel testId={testId}>
        <NsContent>
          <h2>How does the offer work?</h2>
          <p>
            You get a discounted unit rate of 14p/kWh for the electricity your
            heat pump uses. Once you&apos;ve signed up, we&apos;ll add it to
            your current British Gas energy tariff and you&apos;ll receive your
            discount each month for one year.
          </p>
        </NsContent>
        <NsColumn hockeypitch="2">
          <NsContent>
            <h3>How we calculate your discount</h3>
            <NsList>
              {[
                `We’ll use your estimated heat pump consumption which was given at your technical survey and in the email we sent you to work out your monthly usage.`,
                `We’ll then credit your statement each month with the difference between your current tariff unit rate and your cheaper heat pump unit rate of 14p /kWh.`
              ]}
            </NsList>
          </NsContent>

          <NsContent>
            <h3>Rates and charges</h3>
            <NsList>
              {[
                `You’ll pay 14p/kWh (excluding VAT) for your heat pump usage. We’ll add the discount as a credit to your statement each month.`,
                `Your electricity tariff unit rate and standing charge will stay the same.`,
                `If you’re on a time-of-use tariff (e.g. Electric Driver or Economy 7 tariff), we’ll assume that all electricity used by your heat pump was used at peak times.`
              ]}
            </NsList>
          </NsContent>
        </NsColumn>
      </NsPanel>

      <NsPanel>
        <NsContent>
          <h2>How do I sign up?</h2>
        </NsContent>
        <NsColumn hockeypitch="2">
          <NsContent>
            <h3>To sign up for the heat pump add-on you&apos;ll need:</h3>
            <NsList>
              {[
                <Fragment key={0}>
                  A British Gas-installed heat pump.
                  <NsCaveatLink>
                    The offer is subject to availability and can be removed at
                    any time. We will give at least one month’s advanced notice
                    of the offer ending on our website. To be eligible for the
                    offer, installation must be completed within three months of
                    the customer’s acceptance of the sale and customers must
                    sign-up for the product within two weeks of receiving their
                    invitation email. The add-on applies for 12 months from
                    sign-up.
                  </NsCaveatLink>
                </Fragment>,
                <Fragment key={1}>
                  To be a British Gas electricity customer
                  <NsCaveatLink caveatId={switchCaveatId}>
                    You’ll need to switch to a tariff on our new system and have
                    signed up to this offer within two weeks of receiving your
                    invitation email.
                  </NsCaveatLink>{' '}
                  with a supply to the same address your heat pump was installed
                  at.
                </Fragment>,
                `An invitation from us to apply for the offer.`,
                `To pay for your energy by Direct Debit.`
              ]}
            </NsList>
          </NsContent>

          <NsContent spacing="">
            <h3>Not a British Gas customer yet?</h3>
            <p>
              You can only enjoy this offer if you get your electricity from
              British Gas.
              <NsCaveatLink caveatId={switchCaveatId} />
              If you&apos;re not with us yet, it&apos;s easy to switch. To get
              an accurate quote, make sure you use your estimated total
              household electricity consumption included in the email we sent to
              you.
            </p>
            <br />
            <NsSecondaryCta href={process.env.VITE_PATH_PREFIX} target="_self">
              Get a quote
            </NsSecondaryCta>
            <p>
              <b>
                Don&apos;t forget to bookmark this page to complete your
                registration for this add on, once you join us.
              </b>
            </p>
          </NsContent>
        </NsColumn>
      </NsPanel>
    </>
  );
};
